<template>
  <BaseBanner
    v-if="releaseNotesState"
    level="success"
    removable
    @close="closeReleaseNotes"
  >
    Profile builder was updated !
    <BaseButton
      class="actionMessage"
      @click="showReleaseNotesDialog"
    >
      View release notes
    </BaseButton>
  </BaseBanner>
  <ReleaseNotesDialog
    v-bind="releaseNotesControl"
  />
</template>

<script setup lang="ts">
import BaseBanner from '@nicolaudie-group/ng-ui-kit/components/BaseBanner/BaseBanner.vue'
import BaseButton from '@nicolaudie-group/ng-ui-kit/components/BaseButton/BaseButton.vue'

import useReleaseNotes from '@/composables/useReleaseNotes.js'
import ReleaseNotesDialog from './ReleaseNotesDialog/ReleaseNotesDialog.vue'

const {
  closeBanner: closeReleaseNotes,
  openDialog: showReleaseNotesDialog,
  bannerState: releaseNotesState,
  dialogControl: releaseNotesControl,
} = useReleaseNotes()
</script>
